import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
    customScrollBar: {
        "&::-webkit-scrollbar": {
            WebkitAppearance: "none",
            visibility: "hidden",
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#989898",
            width: 4,
            borderRadius: "2px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#ECEDEF",
            borderRadius: "2px",
        },
        "&::-webkit-scrollbar:horizontal": {
            height: 4,
        },
        "&::-webkit-scrollbar:vertical": {
            width: 4,
        },
    },
}));
//# sourceMappingURL=ui_box.css.js.map